import React from 'react';
import Hero from './Hero';
import Schedule from './Schedule';
import Process from './Process';
import Rates from './Rates';
import Solution from './Solution';
import Customer from './Customer';
import Header from '../Home/Header';
import styled from 'styled-components';
import Footer from '../Home/Footer';
import rightLine1 from 'resources/img/rightLine1.svg';
import leftLine1 from 'resources/img/leftLine1.svg';

const RightLine1 = styled.img`
    position: absolute;
    top: 30vh;
    width: 88%;
    right: -30rem;
    z-index: 1;
    @media only screen and (max-width: ${p => p.theme.breakpoints.md - 1}px) {
        display: none;
    }
`;

const LeftLine1 = styled.img`
  position: absolute;
  top: 100rem;
  left: -33rem;
  z-index: -1;
  @media only screen and (max-width: ${p => p.theme.breakpoints.md - 1}px) {
      display: none;
    }
`;


const HeaderWrapper = styled.div`
    min-height: 6rem;
    background: ${p => p.theme.palette.blue.one};
`;

const LiveChatContainer = styled.div`
    position: relative;
    overflow: hidden;
`;


const LiveChat = props => {
  return (
    <LiveChatContainer>
        <HeaderWrapper>
            <Header />
        </HeaderWrapper>
        <Hero />
        <RightLine1 src={rightLine1} />
        <Rates />
        <Customer />
        <Process />
        <LeftLine1 src={leftLine1} />
        <Solution />
        <Schedule />
        <Footer />
    </LiveChatContainer>
  );
};

LiveChat.propTypes = {};

export default LiveChat;